import React from 'react';
import styled from 'styled-components';
import Avatar from './Avatar';

interface Props {
  onClick: () => void;
}

const NewConversationPreview = ({ onClick }: Props) => {
  return (
    <Conversation key="new" active={true} onClick={onClick}>
      <AvatarWrapper>
        <Avatar src={'kindbody-logo'} initials="" />
      </AvatarWrapper>
      <ConversationInfo>
        <MessageHeader>
          <Username>Kindbody</Username>
        </MessageHeader>
        <Subject unread={true}>New Message</Subject>
        <Preview>Draft</Preview>
      </ConversationInfo>
    </Conversation>
  );
};

export default NewConversationPreview;

interface ActiveProps {
  readonly active: boolean;
}
const Conversation = styled.li<ActiveProps>`
  background-color: ${({ active, theme }) =>
    active ? theme.colors.beige : theme.colors.beigeLight};
  padding: 15px;
  display: grid;

  @media (min-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    grid-template-columns: 12% auto;
    grid-column-gap: 1em;
  }
  cursor: pointer;
`;

const MessageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.nightLight};
`;
interface UnreadProps {
  readonly unread: boolean;
}
const Subject = styled.div<UnreadProps>`
  font-weight: ${({ unread }) => (unread ? 'bold' : 'initial')};
  text-overflow: ellipsis;
  overflow: hidden;
`;

const Preview = styled.p`
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: smaller;
`;

const ConversationInfo = styled.div`
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletPortrait}) {
    display: none;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    margin-left: 15px;
  }
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Username = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoints.tabletLandscape}) {
    display: none;
  }
`;

const AvatarWrapper = styled.div`
  position: relative;
  width: fit-content;
`;
